import * as XLSX from 'xlsx'
import helper from "@/helpers/date";

export function role() {
    return localStorage.getItem('role')
}

export const excelParser = (store, moduleName, count) => {
    async function exportDataFromJSON(data, model, newFileName, fileExportType) {
        if (!data) return
        try {
            await store.dispatch(`${moduleName}/getAll`, {params: {order: 'asc', limit: count}})
            let result = store.getters[`${moduleName}/getAll`]
            const filename = 'bonuses.xlsx'
            let newData = []
            console.log(model)
            result.data.data.map(obj => {
                let newObj = {}
                newData.push(newObj)
                Object.keys(model).forEach(key => {
                    newObj[model[key].title] = obj[model[key].data]
                })
            })
            newData.forEach(e => {
                e['Дата'] = helper.datetime(e['Дата']);
            })
            const ws = XLSX.utils.json_to_sheet(newData)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, 'bonuses')
            XLSX.writeFile(wb, filename)
        } catch (e) {
            throw new Error('Parsing failed!')
        }
    }

    return {
        exportDataFromJSON
    }
}
